import { render, staticRenderFns } from "./detail_all.vue?vue&type=template&id=073e1782&scoped=true&"
import script from "./detail_all.vue?vue&type=script&lang=js&"
export * from "./detail_all.vue?vue&type=script&lang=js&"
import style0 from "./detail_all.vue?vue&type=style&index=0&id=073e1782&prod&scoped=true&lang=css&"
import style1 from "./detail_all.vue?vue&type=style&index=1&id=073e1782&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073e1782",
  null
  
)

export default component.exports